import React from "react";
import Chart from "react-google-charts";
import { CardBody, Card, Label, Form, FormGroup, Col, Button, Input, Row } from 'reactstrap'

const pieOptions = {
    slices: [
        {
            color: "#2BB673"
        },
        {
            color: "#d91e48"
        },
        {
            color: "#007fad"
        },
        {
            color: "#e9a227"
        }
    ],
    legend: {
        alignment: "center",
        textStyle: {
            color: "233238",
            fontSize: 14
        }
    },
    tooltip: {
        showColorCode: true
    },
    chartArea: {
        left: 0,
        top: 0,
        width: "100%",
        height: "80%"
    },
    fontName: "Roboto",
    is3D: true
};


class MonitoringPieChart extends React.PureComponent {

    render() {
        return (<React.Fragment>
            {console.log(this.props)}
                {this.props && this.props.data && this.props.data.length > 0 ?
                   
                    <Chart
                        width={'100%'}
                        height={'100%'}
                        chartType="PieChart"
                        loader={<div className ="monitoring-chart-loader"/>}
                        data={this.props.data}
                        options={{
                            title: this.props.title,
                            is3D: true,
                            fontName: "open_sansregular",
                            legend: {
                                alignment: "center",
                                textStyle: {
                                    color: "233238",
                                    fontSize: 14
                                }
                            }
                        }}
                        rootProps={{ 'data-testid': '2' }}
                    /> 
                    : <div>No data Found!</div>}
            </React.Fragment>
        )
    }


}
export default MonitoringPieChart;